
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.296 2.906C3.91 1.805 1.362 4.086 2.193 6.578l1.261 3.741a1 1 0 00.948.681H13a1 1 0 110 2H4.402a1 1 0 00-.948.68l-1.261 3.742c-.831 2.492 1.717 4.773 4.103 3.672l13.802-6.37c2.324-1.073 2.324-4.375 0-5.448L6.296 2.906z"}})])
          )
        }
      }
    